import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect } from '../../../../StyledComponents';

export const Schema = (settings) => Yup.object().shape({
    location: Yup.array().min(1).of(Yup.string().required()).required('Angabe ist erforderlich'),
    becomingAwareThrough: Yup.string().required("Angabe ist erforderlich"),});

export const PreferredLocationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>

        <Form.Label>Für welche Standorte möchtest Du dich bewerben?*</Form.Label>
            {
                
                values.fieldOfLocation.map((field, index) =>
                    <Form.Group className="mb-3" key={index}>
                        <Form.Check
                            name="location"
                            id={field.displayName}
                            label={field.displayName}
                            value={field.displayName}
                            feedback={'Angabe ist erforderlich'}
                            feedbackType="invalid"
                            isValid={touched.location && !errors.location}
                            isInvalid={errors.location}
                            onChange={(event) => {
                                field.onChange(event);
                                handleChange(event);
                            }}
                        />
                        
                    </Form.Group>

                )
            }
            <Form.Group className="mb-3" controlId="formBecomingAwareThrough">
                    <Form.Label>Wie bist Du auf uns aufmerksam geworden?*</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="becomingAwareThrough"
                        value={values.becomingAwareThrough}
                        isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                        isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.BecomingAwareThrough.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThrough}
                    </Form.Control.Feedback>
            </Form.Group>        
        </>
    );
    
};